import type { FunctionComponent } from 'react';

import { Cookies } from '@trello/cookies';
import { convertToPIIString } from '@trello/privacy';

import {
  getDefaultLocale,
  getTemplateLanguageEnabledFromMemberLocale,
} from './Helpers';
import { TemplatesGalleryContent } from './TemplatesGalleryContent';
import type { TemplateLanguage } from './types';

export const TemplatesContainerLoggedOut: FunctionComponent<{
  languages: TemplateLanguage[];
  category?: string;
  shortLink?: string;
  isInAppGallery: boolean;
}> = ({ category, shortLink, isInAppGallery, languages }) => {
  return (
    <TemplatesGalleryContent
      templateLanguage={getTemplateLanguageEnabledFromMemberLocale(
        convertToPIIString(Cookies.get('lang')) || getDefaultLocale(),
        languages,
      )}
      languages={languages}
      category={category}
      shortLink={shortLink}
      isInAppGallery={isInAppGallery}
    />
  );
};
